// Task IDs are scoped. Preserve all three scope parts in navigation and keys.
export function taskKey(task = {}) {
  const scope = task.scope || {};
  return JSON.stringify([scope.organizationId, scope.projectId, scope.environmentId, task.taskId]);
}

export function platformTaskQuery(scope) {
  return scope ? { platform: "1", organizationId: scope.organizationId, projectId: scope.projectId, environmentId: scope.environmentId } : {};
}

export function taskReadPath(id, scope, suffix = "") {
  if (!scope) return `/v1/tasks/${encodeURIComponent(id)}${suffix}`;
  const params = new URLSearchParams({ organizationId: scope.organizationId || "", projectId: scope.projectId || "", environmentId: scope.environmentId || "" });
  return `/v1/platform/tasks/${encodeURIComponent(id)}${suffix}?${params}`;
}

export function taskDownloadPath(path) {
  const url = new URL(path, "https://harness.invalid");
  url.searchParams.set("download", "1");
  return `${url.pathname}${url.search}${url.hash}`;
}
